module.exports = __webpack_public_path__ + "static/media/pexels-photo-1108099.272cb19e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/pexels-photo-1108099.jpg
// module id = 213
// module chunks = 0